/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2575
 */

var r = require(/* 993 */"../../../../../797/101/2466/1167/1435/993")
var i = require(/* 2576 */"./2576/index")
var o = require(/* 2578 */"./2578/index")
module.exports = function (e, t) {
  return o(i(e, t, r), e + "")
}
